/* @flow */

import * as types from 'src/shared/domain/event/action/eventActionTypes';
import { createReducer } from 'src/shared/core/util/reducerUtils';

const initialState = null;

const reset = () => null;

const _setEvent = (state: number, action: Object) => action.result;

export default createReducer(initialState, {
  [types.FETCH_EVENT_SUCCESS]: _setEvent,
  [types.FETCH_PUBLIC_EVENT_SUCCESS]: _setEvent,
  [types.RESET_EVENT]: reset,
});
